import { ConfirmActionDialog } from '../services/ConfirmActionDialog';
import { FeatureFlags } from '../FeatureFlags';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { IApiToken } from '../ServerApi/types/IApiToken';
import { ServerService } from '../services/ServerService';
import { ToasterService, ToastType } from '../services/ToasterService';

export interface IScimSettingsCtrlScope extends ng.IScope {
  secret: string;
  baseUrl: string;
  scimProvisioningEnabled: boolean;
  initScimApiToken: () => void;
  toggleScimProvisioning: () => void;
  selectAll: (event: any) => void;
  openSCIMHelp: () => void;
  alertAndDeleteOldTokensAndGenerateNewToken: () => void;
}

const SCIM_CLIENT_API_TOKEN = 'SCIM_CLIENT_API_TOKEN';

export class ScimSettingsCtrl {

  public static $inject = [
    'ConfirmActionDialog',
    '$q',
    '$scope',
    '$translate',
    '$window',
    'ServerService'
  ];

  constructor(
    confirmActionDialog: ConfirmActionDialog,
    private $q: ng.IQService,
    private $scope: IScimSettingsCtrlScope,
    private $translate: ng.translate.ITranslateService,
    $window: ng.IWindowService,
    private server: ServerService
  ) {
    const getBaseUrl = (scimEnabled: boolean) => {
      if (!scimEnabled) {
        return 'https://';
      }
      //TODO: This is just a hack to get the pod name. It should be replaced with the actual pod name.
      // Or get removed after SCIM starts using MIDS.
      const podName = window.location.hostname === 'localhost' ?
          'local-pod-fake' : window.location.hostname.split('.')[0];
      return 'https://scim.online.tableau.com/pods/' + podName +
          '/sites/' + server.sessionSiteLuid() + '/scim/v2';
    };

    $scope.selectAll = (event: any) => {
       event.target.select();
    };

    $scope.openSCIMHelp = () => {
      $window.open('https://onlinehelp.tableau.com/current/online/en-us/scim_config_online.htm', '_blank');
    };

    $scope.initScimApiToken = () => {
      server.getApiTokens().then((allApiTokens: IApiToken[]) => {
        const scimApiTokens: IApiToken[] = allApiTokens.
            filter(token => token.clientName === SCIM_CLIENT_API_TOKEN);
        $scope.scimProvisioningEnabled = (scimApiTokens.length > 0);
        $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
      });
    };

    $scope.alertAndDeleteOldTokensAndGenerateNewToken = () => {
      confirmActionDialog.open({
        title: Messages.siteAuthenticationScimSecretGenerate(),
        bodyText: Messages.siteAuthenticationScimSecretGenerateConfirmBody(),
        actionName: Messages.siteAuthenticationScimSecretGenerate(),
        action: () => {
          return this.deleteScimApiTokens().then(() => this.createScimApiToken());
        }
      });
    };

    $scope.toggleScimProvisioning = () => {
      var result;
      if ($scope.scimProvisioningEnabled) {
        result = this.deleteScimApiTokens();
      } else {
        result =this.createScimApiToken();
      }
      result.then(() => {
        $scope.scimProvisioningEnabled = !$scope.scimProvisioningEnabled;
        $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
      }).catch(err => err);
    };

    $scope.scimProvisioningEnabled = false;
    $scope.baseUrl = getBaseUrl($scope.scimProvisioningEnabled);
    $scope.secret = null;
    // Make a call to /getApiTokens to initialize the variables
    if (FeatureFlags.scimApiTokenEnabled) {
      $scope.initScimApiToken();
    }
  }

  //TODO: ideally, there should be an API server.deleteAllApiTokens(String clientName) to delete all tokens for a user and client.
  deleteScimApiTokens(): ng.IPromise<any> {
    return this.notifyOnFail(this.server.getApiTokens().then((allApiTokens: IApiToken[]) => this.$q.all(
      allApiTokens.filter(token => token.clientName === SCIM_CLIENT_API_TOKEN).
          map(token => this.server.deleteApiToken(token.id))).then(() => {
      this.$scope.secret = null;
    })));
  }

  createScimApiToken(): ng.IPromise<any> {
    return this.notifyOnFail(this.server.createApiToken(SCIM_CLIENT_API_TOKEN).then((newApiToken: IApiToken) => {
      this.$scope.secret = newApiToken.secret;
      }));
  }

  private notifyOnFail<TResult>(result: ng.IPromise<TResult>, translateKey?: string): ng.IPromise<TResult> {
    result.catch(() => {
      ToasterService.instance.pop({ type: ToastType.Error, text: this.$translate.instant(translateKey || 'unexpectedError') });
    });
    return result;
  }
}
Module.instance().controller('ScimSettingsCtrl', ScimSettingsCtrl);
